<template>
    <div>
        <UsedLandingSearchBox class="used-landing__mast-head" />

        <div v-if="html" class="cms-offer__content-container">
            <div v-for="(page, index) in html.html"
                :key="index"
                :class="[
                    `cms-offer__content-block cms-offer__content-block--${page.template_type}`,
                    (page.template_type == 'two-column-content' && page.is_card) ? '' : page.bg,
                ]"
                :id="page.id"
                v-html="page.html"></div>
        </div>

        <!-- <valuation :activity-type="'used'" :use-full-header="true" ref="valuation" class="cms-content-slice"></valuation> -->
        <valuation-tool></valuation-tool>

        <GetInTouch />

        <div class="container">
            <SiteLinks :brand="brand" />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import getManufacturerFromBrand from "../api/GetManufacturerFromBrand";
import UsedLandingSearchBox from "../components/UsedLandingSearchBox.vue";
import ValuationTool from "../../valuation-tool/ValuationTool.vue";
import SiteLinks from "../components/Layout/SiteLinks.vue";
import GetInTouch from "../components/UsedLanding/GetInTouch.vue";

export default {
    components: {
        UsedLandingSearchBox,
        ValuationTool,
        // Valuation,
        SiteLinks,
        GetInTouch,
    },
    data: function () {
        return {
            address: "",
            page: "used-landing",
            recentlyAdded: [],
            nearlyNew: [],
        };
    },
    computed: {
        ...mapGetters({
            userOptions: "UsedSearchOptions/userOptions",
            loading: "UsedSearchOptions/loading",
        }),
        brand() {
            return this.$route.params.brand || "";
        },
        html() {
            if (typeof this.$store.state.CmsContent.customPages['used-vehicles.' + this.brand] == 'undefined') {
                return null;
            }
            return this.$store.state.CmsContent.customPages['used-vehicles.' + this.brand];
        }
    },
    created() {
        this.$store.dispatch("UsedSearchOptions/resetUserOptions");
        if (this.$route.query) {
            this.$store.commit("UsedSearchOptions/setUserOptions", this.$route.query);
        }

        // Brand in URL can now be any slug set in the CMS. If it's not one of the main brands, then this function will set the manufacturer to "Stellantis &You UK"
        let manufacturer = getManufacturerFromBrand(this.$route.params.brand);
        if (manufacturer == 'Stellantis &You UK' && usedManufacturer) {
            manufacturer = usedManufacturer;
        }
        if (this.$route.params && this.$route.params.brand) {
            this.$store.commit("UsedSearchOptions/setUserOptions", {
                manufacturer,
            });
        }
        this.$store.dispatch("UsedSearchOptions/updateOptions", {
            nearlyNew: 0,
            new: 0,
        });
    },
    mounted() {
        this.$store.dispatch("CmsContent/getCustomPageContent", {
            page: 'used-vehicles',
            brand: this.brand,
        }).then(() => {
            this.$nextTick(() => {
                window.reloadCMSContentSlices();
            });
        });
    },
};
</script>

<style lang="scss">
@import "../../../sass/redesign/variables";

.used-landing__mast-head {
    padding-bottom: 45px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/used-vue/views/used-landing.vue